import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Button } from "@mui/material";

import { PAGE_ROUTES } from "../../utils/stateTypes";
import { TileArt } from "../home/Hero";

const styles = {
  main: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    padding: "220px 0 100px 0",
    boxSizing: "border-box",
  },
  grid: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 48,
  },
  text: {
    margin: "20px 0 32px 0",
    maxWidth: 420,
  },
};

const NotFound = () => {
  return (
    <section style={styles.main}>
      <Helmet>
        <title>Page not found | Corlea Geyer</title>
        <meta
          name={"robots"}
          content={"noindex"}
        />
      </Helmet>
      <div
        className={"container"}
        style={styles.grid}
      >
        <div>
          <h1 className={"section-title"}>Page not found</h1>
          <p style={styles.text}>
            The page you&apos;re looking for doesn&apos;t exist or has moved.
          </p>
          <Button
            component={Link}
            to={PAGE_ROUTES.HOME}
            variant={"contained"}
            size={"large"}
          >
            Back to home
          </Button>
        </div>
        <TileArt className={"not-found-art"} />
      </div>
    </section>
  );
};

export default NotFound;
